import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, Signal, signal } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ITableColumn } from 'src/app/core/models/table.model';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { IPrelievo, PRELIEVO_STATUS, getStatusIcon } from '../models/prelievo.model';
import { QueryService } from 'src/app/core/services/query.service';
import { CONTROLLI_DETTAGLIO_COLUMNS,PARAMETRI_ALERT_COLUMNS,PARAMETRI_OBBL_MANCANTI_COLUMNS, PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE,PRELIEVO_EX_QUERY_SERVICE_INSTANCE } from '../prelievo.config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { InputDateComponent } from 'src/app/shared/components/inputs/input-date/input-date.component';
import { MatBadgeModule } from '@angular/material/badge';
import { FiltersGroupComponent } from 'src/app/shared/components/filters/filters-group/filters-group.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IInputToggleGroupOption, InputToggleGroupComponent } from 'src/app/shared/components/inputs/input-toggle-group/input-toggle-group.component';
import { FiltersPanelComponent } from 'src/app/shared/components/filters/filters-panel/filters-panel.component';
import { ActivatedRoute, Router } from '@angular/router';
import { IParametriAlert } from '../models/parametri-alert';
import { ApiService } from 'src/app/core/services/api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ControlliService } from '../controlli.service';
import {TableComponent} from '../../../shared/components/table/table.component'
import {MatTabsModule} from '@angular/material/tabs';
import { of } from 'rxjs';
import { ParametriObblMancanti } from '../models/parametri-obbligatori-mancanti.model';
import { InvioDatiPageComponent } from "../../trasmissione-reportnet/invio-dati-page/invio-dati-page.component";
import { TrasmissioneReportNetService } from '../../trasmissione-reportnet/trasmissione-reportnet.service';
@Component({
    selector: 'app-lista-dettalio-page',
    standalone: true,
    templateUrl: './lista-dettaglio-page.component.html',
    styleUrl: './lista-dettaglio-page.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MatBadgeModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatTabsModule,
        MatDividerModule,
        MatTooltipModule,
        TableComponent,
        MatIconModule,
        PageListComponent,
        InputDateComponent,
        InputToggleGroupComponent,
        FiltersPanelComponent,
        FiltersGroupComponent,
        InvioDatiPageComponent
    ]
})

export class ListaDettaglioPageComponent {  
  filterForm: FormGroup;
  //configurazione per la tabella della lista dei dettagli
  uuid?: string =this.activeRoute.snapshot.paramMap.get('uuid') ?? '';
  dataOraPrelievo?: string=this.activeRoute.snapshot.paramMap.get('dataOraPrelievo') ?? '';
  data = this.queryService.store.selectKey('list');
  columns: ITableColumn[] = CONTROLLI_DETTAGLIO_COLUMNS;
  insertForm: FormGroup;
  @Output() parametroAlertInsert = new EventEmitter<string>();
  customClickFunction:Function=(row:any)=>{
    if(row.id){
      
      this.navigateToDetail(row.id.toString())
    }
  }

  // configurazione per la tabella dei Parametri di Alert
  datiParametriAlert:Signal<IParametriAlert[]>=signal([]);
  columnsParametriAlert: ITableColumn[] = PARAMETRI_ALERT_COLUMNS;


  // configurazione per la tabella dei Parametri obbligatori Mancanti
  datiParametriObbl:Signal<ParametriObblMancanti[]>=signal([]);
  columnsParametriObbl: ITableColumn[] = PARAMETRI_OBBL_MANCANTI_COLUMNS;

  statusOptions: Array<IInputToggleGroupOption> = []

  constructor(
    private readonly fb: FormBuilder,
    @Inject(PRELIEVO_EX_QUERY_SERVICE_INSTANCE) public readonly queryService: QueryService<IPrelievo>, //queryservice  per dati filtrati con punto campionamento e data
    @Inject(PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE) public readonly queryServiceErrori: ApiService,//queryservice per i parametri alert
    private readonly controlliService: ControlliService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public readonly trasmissioneReportNetService: TrasmissioneReportNetService
  ) {
  this.insertForm = this.fb.group<any>(<any>{});
  this.filterForm = this.fb.group({
      search: this.fb.control('', []),
      filters: this.fb.group({
        dataPrelievo_greaterThanOrEqual: this.fb.control<Date | null>(null, []),
        dataPrelievo_lessThanOrEqual: this.fb.control<Date | null>(null, []),
        dataAnalisi_greaterThanOrEqual: this.fb.control<Date | null>(null, []),
        dataAnalisi_lessThanOrEqual: this.fb.control<Date | null>(null, []),
        status_in: this.fb.control<Array<string> | null>(null, [])
      })
    });
    this.insertForm = new FormGroup({
      uuid: new FormControl(this.uuid, [Validators.required]),
      dataOraPrelievo: new FormControl(this.dataOraPrelievo, [Validators.required]),
      parametro: new FormControl('', [Validators.required]),
      tipologiaPuntoDiConformita: new FormControl(null, [Validators.required]),
      superamento: new FormControl(false, Validators.required),
      superamentoNonSignificativo: new FormControl(false, Validators.required),
      superamentoNonSignificativoGiustificazione: new FormControl(),
      superamentoPopolazioneInteressata: new FormControl(),
      superamentoDataInizio: new FormControl(),
      superamentoDataFine: new FormControl(),
      superamentoCausa: new FormControl(),
      superamentoAzioneCorrettiva: new FormArray([]),
      superamentoAzioneCorrettivaDataInizio: new FormControl(),
      superamentoAzioneCorrettivaDataFine: new FormControl()
    });
    PRELIEVO_STATUS.forEach((status) => {
      this.statusOptions.push({
        label: getStatusIcon(status) + ' ' + status,
        value: status
      });
    })

    if(this.uuid!=''  &&  this.dataOraPrelievo!=''){
      const httpParams = new HttpParams()
      .set('uuid', this.uuid!)
      .set('dataOraPrelievo', this.dataOraPrelievo!);
      this.datiParametriAlert = toSignal(this.controlliService.getParametriMancanti(httpParams.toString()), { initialValue: [] });
      this.datiParametriObbl = toSignal(this.controlliService.getParametriObbliMancanti(httpParams.toString()), { initialValue: [] });
    }
  }


  handleEvent(event: any) {
    this.insertForm?.reset({ 
      superamento: false,
      superamentoNonSignificativo: false
    })
    if(event?.parametro){
      this.insertForm.get("uuid")?.setValue(this.uuid);
      this.insertForm.get("dataOraPrelievo")?.setValue(this.dataOraPrelievo);
      this.insertForm.get("parametro")?.setValue(event.parametro.parametro);

    }

  }
  handleError(error: any): any {
    throw new Error('Method not implemented.');
  }

  async ngOnInit(){
        // verifica se presente uuid e dataOraPrelievo e effettua il filtro sulla get
        if(this.uuid!=''  &&  this.dataOraPrelievo!=''){
          this.queryService.store.setKey("filters", {"puntoCampionamentoUuid.equals":  this.uuid , "dataOraPrelievo.equals": this.dataOraPrelievo})
        }
  }


  get filters(): FormGroup {
    return this.filterForm.get('filters') as FormGroup;
  }

  get prelievoFiltersCount() {
    let count = 0;
    const fields = ['dataPrelievo_greaterThanOrEqual', 'dataPrelievo_lessThanOrEqual'];
    fields.forEach((field) => {
      if (this.filters.value[field] !== null) {
        count++;
      }
    })
    return count;
  }

  private navigateToDetail(id: string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    const indexFind = urlSegments.findIndex((element) => element == 'controlli')
    urlSegments.splice(indexFind+1, urlSegments.length)
    urlSegments.push('dettaglio');
    urlSegments.push(id.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
  }
}

